export default "__VITE_ASSET__BES_kzs1__"